export const FarmgodCore = {

	

	"echo": {
		"hide": true,
		"name": "ECHO",
		"address": "0x54477a1d1bb8c1139eef754fd2efd4ddee7933dd",
		"icon": require("../gdeli/echo.png"),
		"decimals": 9,
		"scope": "interuniversal",
		"type": "-",
		"archetype": "reflective",
		"tax": "2%",
		"pools": [{"chef":"acremaker", "pid":2}],
		"max": "69420000",
		"staticimg":"https://maxus.blog/static/media/echo.60b77b4b.png"
	},
	"deflaton": {
		"hide": true,
		"name": "DEFLATON",
		"address": "0xfd3b077dc97915ab3a49db1b1021c13ad55751dc",
		"icon": require("../gdeli/deflaton.png"),
		"decimals": 9,
		"scope": "interuniversal",
		"type": "-",
		"archetype": "reflective",
		"tax": "2%",
		"max": "1000000000000",
		"staticimg": "https://maxus.blog/static/media/deflaton.f61bcea1.png"
	},
	"gigadeflaton": {
		"hide": true,
		"name": "gigaDEFLATON",
		"address": "0xb0a3bF98516D6CE466D2F78Bd6a494EF8FfB396D",
		"icon": require("../gdeli/gigadeflaton.png"),
		"decimals": 9,
		"scope": "interuniversal",
		"type": "-",
		"archetype": "reflective",
		"tax": "9%",
		"max": "1000000000000",
		"staticimg": "https://maxus.blog/static/media/gigadeflaton.8750fba7.png"
	},
	"distributon": {
		"hide": true,
		"name": "DISTRIBUTON",
		"address": "0xCB27360cDC3493C7806D2c796323b7639C028231",
		"icon": require("../gdeli/distributon.png"),
		"decimals": 9,
		"scope": "interuniversal",
		"type": "-",
		"archetype": "elastic-rebasing",
		"tax": "-",
		"max": "-",
		"staticimg": "https://maxus.blog/static/media/distributon.1eb0c2de.png"
	},
	"gdeli": {
		"hide": false,
		"name": "gDELI",
		"address": "0xfa1807bd24a438b389ca33072375dfbba74dfaab",
		"icon": require("../gdeli/gdeli.png"),
		"decimals": 9,
		"universe": "Deliland",
		"scope": "deliland",
		"type": "core",
		"archetype": "reflective",
		"tax": "2%",
		"pools": [{"chef":"acremaker", "pid":0}],
		"max": "417",
		"staticimg":"https://acres.maxus.blog/static/media/gdeli.dbb2f4f6.png"
	},
	"acre": {
		"hide": false,
		"name": "ACRE",
		"address": "0x12245af2d6d298D98019C15FB1001D8712D27A7D",
		"icon": require("../gdeli/acre128.png"),
		"decimals": 18,
		"universe": "Deliland",
		"scope": "deliland",
		"type": "core farmable",
		"archetype": "capped inflationary",
		"tax": "-",
		"pools": [{"chef":"acremaker", "pid":1}],
		"max": "37000000000",
		"staticimg":"data:image/png;base64,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"

	},
	"yomopu": {
		"hide": false,
		"name": "YOMOPU",
		"address": "0x6FA9979E4403C0048eb4cf830c5B088459e20939",
		"icon": require("../gdeli/YOMO256.png"),
		"decimals": 18,
		"universe": "Deliland",
		"scope": "deliland",
		"type": "special ingredient",
		"archetype": "standard inflationary",
		"tax": "-",
		"pools": [{"chef":"puchef", "pid":0}, {"chef":"bobachef","pid":0}],

		"max": "∞",
		"staticimg":"https://www.yomopu.maxus.blog/static/media/YOMO256.acd5d8e6.png"
	},
	"salt": {
		"hide": false,
		"name": "SALT",
		"address": "0x681a02302213c09171ddd45232cc5652e95ccc83",
		"icon": require("../gdeli/salt.png"),
		"decimals": 18,
		"universe": "Deliland",
		"scope": "deliland",
		"type": "ingredient",
		"archetype": "simple inflationary",
		"tax": "-",
		"max": "∞",
		"staticimg":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAACXBIWXMAAAK7AAACuwEJQkcmAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAF0pJREFUeJztnWmMJGd5x//PW9XdMz3Tcx+7swt4WY4o5ggoJARLCQKUgNfGiCCLUyFKRAiRiBSFiJysQoJihMKRD4kiEkRiTGQSLgvHFoucD6CgyOIQBjaxvWAvu8zO2T1XH1X1PvnQvT3V1dVHdVVPVXc9vy+w4663n56pf7/P9T4FCIIgCIIgCIIgCIKQCChuA9LOgw/eO2NU9ISRNaZtNgpkO6Zi48gmLjsZXVJq/uj222+vxm1nWhGBDJEHH3wwp5y9n2GN8wDOK8J51vwcEM4DWAIw3edSDMIuGD8h4EmAn9CMJwnGk07GfvzChbc9NbxPkW5EIBHy8MP/MqVr5kuI6TYwv4ZAtzEweQJvvQ7gURC+To6+9N/fffzbFy9e1CfwvmOPCCQkX33g/mfaWr+JwL8O4BcAmHHbBMIOgIeI+HOlsvnw3XffXY7bpFFFBDIAjzzyiFnd/+ldYLwboFcj0b9HKjLjXxnqH25/w90/iNuaUSPBf9jkcf/992dnJ/Q7mfn9AM7FbU9AGMADCvjgr971lkfjNmZUEIH0ycNfvu9VzPQJALcOcv3u7i6efvoqyuUjTOWn8KxbnoWZmZme11VrNVy5cgWlYhHZbA6nVlexdmZtEBNuwmDc62SMP7pw4e71MAulgfj95YTzyCOfmqjtT9zDjPeGWWd9fR1XrlxB+aiMqcIU8tNTfQlkf28fV564gtL+HrKmiWq1ElYgBMI7DNt5/UNfvu9dr339W+8Ps9i4IztIFy596b5VG+ohgH8ubluGBDPwl6+76y0X4zYkqYhAOvDAA/ctZTR9A8Dz+r2mWCzixo0N2LaFmUIBa2fPwlCq53XVahXXr1/HwcEB8vkpnD59Gvl87+wwM+Pa9esoFfdgGISlpWUsLS32a65rIdzz2je85f3BLxx/RCA+XLx4Ub38pc//GhivDHLdpa9+DdeuX0O5UsH87Bxe+cpfweqp1Z7XXb58GY8++i0cHB4gP5nHC19wK17y0pf0vK5YLOLSVy9hZ7cI0zSxvLyEOy7cDupDlF4Y/I7X3fXWewNfOOaIQHz4zy9/9reI8cm47ThhSqZTO/+aN/7GdtyGJIngXzUpQAF/GrcNMTBbU9nfjNuIpCEC8fDgF/7tPHP0NQ7bsvGTa9fww8uXsb5+A8zc97VbW1v44eXLuPr006jWalGb1kQRv3Noi48okub1QBm8GE70637+81/At7/znea/77jjAm677RU9r3vsse/jM5+5r/nvc+fO4V3v+u3oDQQA0KgVP4eOxCAevvLAve82tPH3Ua+rtcbGxiYODvaxsLCAhYWFvq8tFovY3t7BZH4SK8vLMM1hfa9R9bV3vXliSIuPJLKDeFDauD6UdZXCqVOrAHpntbzMzc1hbm4ueqO8MKzhv8loITGIB23q78ZtQ3zox+O2IGmIQDxcuPC2pxh0OW47YsGgf4rbhKQhAvHnL+I24KQh4EaubHw6bjuShgTpHbj0lf/YtO3aUtx2nBTZienff9Wv3fmJuO1IGrKDdGBiavZHWvdfqxhlapaNueXF78dtRxIRgXQgYxo/qVRqcPQ4H+1mVC0LlmXDMPh7cVuTREQgHVCm8WkGo1KxULPtuM2JHM2MctWCbTkozMwdvvjFt23EbVMSEYF04GUv/+UvzczM1QCGVbNRrlTHYjdhALbtoFypQjv1z1MozMihqQ6IQLqQMY1vGoYBANCaUanUUK3WoEdQKE1hlKuo1qz6DwDMzs5hr7T74ViNSzAikC4cVQ6+NTc/D6LjZJ/taJQrNZSrNdi2g+ad1vL/koNmRs2ym8JwN0lO5qfA2gJzzYjRxEQjrSZdMEj9sHJ0gIWFRRSLu3Cc4y5G7WhUHY1ajWCYCoYyYJiEJGTOmRm248CxdUe3cKowA4McaNspW6rwoxM2cWSQHaQbdu2LACqV8gGmpwuYyrdPCmUwbNtBtVbD0VEV5UoVtZoF23YCtbSHQWuGZTuoVi2Uy1Uclauo1eyO4lhYWgIcC47tgIEH7rzzzqMTMXQEif/rLuE89MXP/jUIfwIAREBusoDi7k7LbtINIoIiAqnG/xJBNY7EkqqPGOnGscYYmjVY1wWhmcHMYM3gPp27qakCsjkTtUpz0GLVcehFF9745v/ra4EUIi5WD5Zu7F3cPbPwasexf5EZqBztIz85gexEvu529UgBMzMcZqBXXE91sRDVr2EmRBXVTE1NI5fLoVo5RK1y3LBLRO8VcXRHdpA+uHH16sUnHn/sA/v7Rc9/IeQmJmE7jIP9UqKyW2Ymg5mZWWjbgmW1Pz3hlnPPw+oznj0/Pz/v/VCCC9lB+iCfz8/f+sKfx5UnfoCNDfdxEUa1Unffp/OTyOTysB0Hh4f7sK2TP1qRn5xCLj8JsEa1coRq+aDtNYaZwXOf87NYXFoFmM8CEIF0QQTSH2cNpfDc570AC4sr+NGVy6hWKy0vcLQDp7wPAMhlDEzlJ2FmctBao1qtolIuQ+vozvJmsznkchPIZLMAHFjVCrR2UGuIws81WFhYwbnzz8dErj5zi5jPAHgsMqPGEBFIHxBw5mY0sLi4grn5JaxffwrXrj0Fy/IOUWAABNuqwW78NwIwOZEBIQszl4NSZqO2Qo14Q4MZYO2AQVCqHotQPYpvBvKsNRy7BsuyQARop4pquffDp2Zm5/HMZ57H7GzrMV8NnA31i0kBIpA+YM+NZCiFM2fP4dTas7C9fQObN66jVNpppHU7h3UMhuXZefzotc9QH5GjmclieWkVKytrmC7M+q8DnOm9UroRgfSAmY2DnZ1VAFCG0Uit1oNxQymsLJ/GyvJpVGtVbG38FNvbGzg43Gu+5iTJZLKYnZ3H8sppzM0tNdPJjc8B1hrKaCmai0B6IALpQXl7+xSI6r8nw4BpmNC2Dce23EUK5LI5nDl7C86cvQVaO9jbL2GvtIO90i4ODvd7poMHITcxiZmZOcwU5jAzu4B8fsr3dY7jwLYtkFLIugTi3RmFdkQgPbCAsze/hxUpgAgqk4EyTWjLgrbttkKdUgbmZhcw5/L5LauGaqWMcvkIlUoZlcoRtHZg2za01tDagdUQkVIEQ9XFSIYBQylkMjlMTE5iMjeJickp5CYmW3YIPxzHhm3bx9Z5KvviYvVGBNID1ekmIoLKZqGyWbDW0I4NbdttN+FNMpksMplsx3ggCrhRXdeOA1vbaIuHuM3tkx2kByKQ3hzfRB2iY1IKhsrCyDTEoh1oy+oolqixHbue4dIOjkXRbiu3/2yRr16dpGc8Qx7y2QFpVuxBixvSR/qIlIJhZkAn2PvuODcbE3vbpz2iLRUKoR5XNe6IQHrADYFQo9Gw/+uSeDoEbbuaUa+mCx0QgfSmfgMFEMdJuVY3Ier/z8ieOKRRTRc6IALphVLBb6AgYjphvNKVanp3RCC9aHzDBvuWPuEdJMBrvbbJDtIdEUgX9vb2FgE0OvuS62IFgdptE4F0QQTSBWXbzZuHVHLdpmDJgzZEIF0QgXQhaIq3yQnvIEHezedQl8QgXRCBdMFxpUADxSAnnOLtda7djU98dJqZZexPB0QgXRi0V+kki4RAMBcLRF6RGEdbW8Efe5USRCDdGcjFOuksVlCXzvtqm0jcrA6IQLpwsx08cBX9hOP5QDsI2jNZ0tXbGRFIF5o3TuAbcBjWREdbLUQC9Y6IQLoTvM0EMRQKA6agvdbJDtIZEUgH+Pr1PID5Aa+O1Jao383bj6VFIB0RgXRgzzSbN40KkOIFcOJj3oOGPN7z8qSUuFgdEIF0QLkzO4Gr6CcdhIRzsSD9WB0RgXSADGOwKjpiiEGC2tcuEdlBOiAC6YC7DTxIFb1xRcTW9CZI9d5HwJOlUmnB77VpRwTSgYH7sADE8awpFUiU7ZPjDccRN8sHEUgnXH55YHkkuN39Jj6pXnGzfBCBdKBZRQcFLxQOxaJo8WayHAnUfRGBdKDpYg1wDiSOHSRwoC7V9L4QgfjAzCaAeodrwjNYgyIHp/pDBOJDeWfnNID6GYkRca/C7iAsAvFFBOKD5bpZgmWHYtxBgr6vuFh9IQLxQfUxbrQjsW0hwf6U4mL1hwjEh5YaSNAgPa4QJHgu2vuThUaDpuBCBOLPcQ0kcKNiPAoJGoN4Z/QCrQ2aQh0RiA8cwsVK7ExeH7zxkiISgXgQgfgzcBU9Ln0MEvq0VdMNQwJ1DyIQfwYP0kekDgKgzVY5ONWOCMQDMxOANaD+rI/A149MlO5bTReBeBCBeNjf318EMAFgoCntQYa4RUnQIL2OR8zyrJA2RCAelOO4zoEM8K08wkG67CDtiEA8uLtagx+UQnwxyCBi9nT0ymOh2xGBeFBhb5K4NpABhOlzxWqjUVNoIALx4j4XMUire0wKGcgdbBeVUd7ZORWJQWOCCMQDhamiAyOV5vWz1BI3qwURiAduGdYwCmcD6wxqa1s1XQL1FkQg7YQY1oB4d5AI3lva3lsRgbQT6gaJ08Ea5DFx3kwWZAdpQQTiYn19fQrALDBYFT1+wicVWIY3tDCKd8HQyLub9QaNP2J0sQbLZLX9SATiQgTiwj2PN6K0aeLxsVliEBcikFZCpXhHJ+flwvMoBBCdaTRsChCBtKDDtLkj/h1koHbF9osm9vf3ZU5vAxGIi9Z5vIOsEK9ABnl3P1G7GzbTjgjEjVLhaiAxO1lqwCC9ratXMllNRCCtNL85Az9VCvG7WIO/e9vJQtlBGohA3Li/OaM4gHTCDCJqQJ441Q0RSANmzgBYBhCiBhKdPYO9/4AGyMGpjohAGlR2d5vzeAc/NhtzFiuihkU5OHWMCKSB5TqPPUhPExB/DDKormUMaWdEIA3CPXKtcVnc+ohoB4HsIE1EIA0o1EM764zSwAY3PgKZ29jYmI7DlqQhAmmgI9hB4pYHD+hj+bmGE0RrYe0ZB0QgDcbCxRr0Qh+BkKtxM82IQI5xuViDLTCyLhbJjKxOiEAahB7WAMQ+sGHgM/Q+Zks1vY4IBPV5vMx87HOP0LCGqGib9O7uS0sxIhAABzduLIMoByCcOOKugyDSOEQEAhEIAEDlcuHdKySgUBgC7R1DKoOsAYhAAABOBFX0pDBwsRASpPshAoHcDAD8XKzVRgNnqhGBABG0uScnxRvhNEjVaOBMNSIQRNNmEneRsMmAcZBf/GTJuRARCABwFG0mCQnQB+4j86umSy1EBNIgfKt7QlysQQf2aB/7JTYTgdzE9djn0ezDCguB2lK98tRbEQg2NzcLAGaaPxh5F2vwIN17pbhYIhBMuLtWw2SARrt8AsDXTZQdJG4D4sbtZw86FQRA/IdBGoTRqU9Hr+wgcRsQN2HHjR6TEIWEwPsJmHkt7XN6Uy+Q8ONG6yQnBgnRS6Y9n4Eod3BwsBTSpJEm9QJBBDUQAOOwgfh+QSjbTrWblXqBRFFFr5MQhYQQudZO28+clFfTUy8Qdh0MCpMiTYqLFQappreTeoHAfe4hTA0hIacQI7dCdpD0wsxZAM0gNMyDO8dhBwFIhjd4SLVAisXiGiL6HYx6q8kxMqfXTaoFYkTkXgHJaVasu3ohnhQiZ9NbSLVA3E9SChtDjIeLBWgRSAvpFkhkKd5kuVgRZ+NmGw2dqSTVAmlp5w45rCEpLladaEcX5YhSu4ukWiCRZWgS5l5FnXJWKXazUi0QROViJaQGEgUdYqnUZrJSLRBumcc7PlX0UA0zPp8lzScLUysQZlYEHI+1GfGRo27CWMNgKRa6SK1ADjc3VwBkmz8Y8YmKbsLFIO3VdCglLlbaIE9mZvAn2yJxO8gQkB0kbTius+ihi4SJSvECYVsW23aQFA+yTq1AWp5/EVIgSSoSAkPpLF5h5lzUi44CqRUIoniiVIOE6SO0y8esvT+iSrF4KtSiI0pqBcLucw5jVUWPYAfxn9ObSjcrtQKhyKaZJM/FCntqyu/jUEoPTqVWIHDPw4o6qI2ZsDuIdwQpkN6jtyIQIIJWkWQJJKw1Uk0/JpUC2dnZmQVw3MId2mcPd3nUhKrpAL6/j7RW01MpkIzXnx6zHSQKuN3NEhcrLXgD9HE7TRhJHYTa/ik7SFrQEXXxHpO8Pq6wqWev6Bk4w8ypu19S94GBYWRkkrWDAOFTzz5n0zOHGxvL4VYdPVIpEERYRQeS52IBwxlC0dKekxJSKRCK4LHPLeuFXiGB+AjESWGgnkqBsPupUhGcAxnLHcRvTcOQHSQVyDysnnT4XCKQcYeZcyA6nscb0kFKqnsVvmGxvd2EU9iwmDqBlEqlM3Df10NwRcYB9pF+GmshqROI0jolVfShxFayg4w7qmUWVvgq+hjrQwZZI4UCQcQp3qQObIiiQ8DnZGFhe3t7JvTCI0TqBMKRtrkn7zRhlPh9smzK3KzUCQRuFysSPyT8EkmlwzMLU+VmpVEg6XCxoljD/+CU7CBjzvEOEkUVPbFbSBSfzWfVlJ1NT5VAGu3ax+NrIunDSmapMJogXarpqRLI0dbWKoDMzX9H0smb2B0kPDK8IWUCgbtJMSoSGoNEEl9R+yBrlh1kfHG8f9xIgvTwSwyFiITbtkrKHseWKoFQ1FV0JNfFimo+r08mazlNc3rTJpBoU7xAcl2siPAJ1KlUKq3FYUscpEogOsKJ7k0Sqo+odhC/j9fW8DnGpEogw8nAJFQhAKKwzacfK1WZrFQJxN2oqCJI8QLJlkckMZZfqjdFxcJUCaQlBonomYTJLBPeZDjV9DTN6U2NQIrF4jwDU80fROWjj3uQ7iMRcbHGEMMTWI7rPCw30m4SntQIhLwDB2QeVp8QfBwt2UHGjTa/2XFCr5n4HSSCNQyl/Eo9p5nZiGD5xGPGbcBJoYAZ99/ZrlVBjg0jkwWpQb8nki2QUNYxI5PJwjB8dZDBj3+cARD+WybhpEYgTFT2fhWy48DWFSjThJHJDrBqsp0sRYT2JG1vDKVgmma3OM2hc+cqIUwbGdIjEObv+t7OzNCWBXac+m7i/43Zac3I7BsOwQRMBGTMLFTvHfV/BjZpxEhNDFJYWPgmgCud/jtrDbtagV2rBlg12QIJksUyDRPZTK4fcQBE94Ywa6RIjUCIiIn5d9Djrmbbhn10BG1ZvRdNtj76aqRURMjlcg2Xqi9BfWN6fv4fQ9s2IqRGIAAwvbR0CUS/B6Dr3c9gOFYNdqXs22rhfmWS6XbDE4CMaSKbzQU5Nvx1cpw3EZEdhX2jQLKjzCGxt739CgL+HsCL+nm9ymSgzEzbDedYtf52mpjQ2kGtzT6GqUwY/e8YALAP5numFxc/TETJ/cBDIJUCAeoDHA63t9/OwEdA1PPRYkQEI5trCeJ1rQbHTu794hWIIkLGzARJa9sA/pkc5wPTKyvrw7Ax6aRWIDcpFovzhuNcBPAe9JHVU4YBI5sDiODUqtB2cr0NZo1qrQaAYRgmMmam5zUuLhHRH0wvLHxvSOaNBKkXyE32NjefD6U+SsDrer2WiKDMDLR2wBFU5IeFZoZtWzDNDFSf7hQDj5LW7yssL//XcK0bDUQgHvZ2du4k5o8BeHbctpwwV0H0V9Pz858kokHqi2OJCMQHZs4e7uz8LgMfBFCI254hs8tE9xRKpY+npToeBBFIFw43N9ccw/gbYn47xu93ZQH4FLLZPysUCptxG5NUxu2PPhQOt7Zepok+DuCX4rYlAhjAvzuG8cdzc3NPxm1M0hGB9Akz0+H29juY6B645/uOFt9koj+cWVj4RtyGjAoikICsr69PTWUy7wPz+0E0KgPU/hfAnxcWFz8XtyGjhghkQEobG881lPpbJrojblu6sMVEHynMz3+UiGpxGzOKiEBCcrC19Rom+hiAW+O2xcURMf9dlehDi4uLe3EbM8qIQCKgkRZ+D4D3MnAuRlP2wHyvAXwov7R0LUY7xgYRSIQwszrc3b1VO845Uurk4hNmRwPXZmq179Ha2tGJva8gCIIgCIIgCIIQKf8PL7IzEjyPyKIAAAAASUVORK5CYII="
	},
	"water": {
		"hide": false,
		"name": "gH20",
		"address": "0xD802dF71F737F9C687c5d389FD6AC421d0666f10",
		"icon": require("../gdeli/watertoken256.png"),
		"decimals": 18,
		"universe": "Deliland",
		"scope": "deliland",
		"type": "ingredient",
		"archetype": "complex inflationary",
		"tax": "-",
		"max": "∞",
		"staticimg":"http://deliland.io/static/media/watertoken256.d860f17d.png"
	},
	
	
	"eye": {
		"hide": true,
		"name": "EYE",
		"address": "0x496e1693a7b162c4f0cd6a1792679cc48ecbcc8d",
		"icon": require("../gdeli/eye.png"),
		"decimals": 18,
		"universe": "Truth",
		"scope": "truth",
		"type": "core",
		"archetype": "fixed",
		"tax": "-",
		"max": "-",
		"staticimg": "https://eyeoftruth.io/static/media/eye.e1cc0e45.png"
	},
	"munny": {
		"hide": true,
		"name": "MUNNY",
		"address": "0x195fe0c899434fb47cd6c1a09ba9da56a1cca12c",
		"icon": require("../gdeli/munny.png"),
		"decimals": 18,
		"scope": "multiversal",
		"type": "-",
		"archetype": "fixed",
		"tax": "-",
		"max": "1010000",
		"staticimg": "https://maxus.blog/static/media/munny.be0ba729.png"
	},
	"tapioca": {
		"hide": true,
		"name": "TAPIOCA",
		"address": "0xf29de415db17bfb803fa2af75151f0c6f9c06b10",
		"icon": require("../gdeli/Tapioca.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "standard inflationary",
		"tax": "-",
		"max": "?",
		"staticimg": "data:image/png;base64,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"
	},
	"energ": {
		"hide": false,
		"name": "ENERg",
		"address": "0x126eE076DA8cc4ffCA5cd89BB4a0EbfE6Fa09189",
		"icon": require("../gdeli/EnerG-icon.png"),
		"decimals": 9,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"penerg": {
		"hide": false,
		"name": "ENERg",
		"address": "0x5740bc97388e468829e5d43bcf3e56dac65fdc1a",
		"icon": require("../gdeli/pEnerG-icon.png"),
		"decimals": 9,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"mgdeli": {
		"hide": false,
		"name": "ENERg",
		"address": "0x16DCdC7BB3235a60243b34875c9D86a4980Da26d",
		"icon": require("../gdeli/mgDELI-icon.png"),
		"decimals": 9,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"ugu": {
		"hide": false,
		"name": "UGU",
		"address": "0x3f9C449FEBb5e8cC452637ACe9287dD806F49B86",
		"icon": require("../gdeli/deliland-ugu-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"liggies": {
		"hide": false,
		"name": "LIGGIES",
		"address": "0x6e9c4Fe1D8509ED2d4219C21FbaB232A81b8d4b6",
		"icon": require("../gdeli/deliland-liggies-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"sugarcane": {
		"hide": false,
		"name": "CANE",
		"address": "0x54546a860416483994E7E83803A72d59D15fBAA3",
		"icon": require("../gdeli/deliland-cane-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"wheat": {
		"hide": false,
		"name": "BUSHEL",
		"address": "0xB6F07FcD05E90D46b411f4F4F1c0665227bCdd35",
		"icon": require("../gdeli/deliland-wheat-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"gseed": {
		"hide": false,
		"name": "gSEED",
		"address": "0xDbE808E1968B0C8978Ad7d13255CBA8aC659Ea0a",
		"icon": require("../gdeli/deliland-gseed-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"animal": {
		"hide": false,
		"name": "ANIMAL",
		"address": "0x1f365ac62aabf64ef52a2c2fd86df9dd9e03665f",
		"icon": require("../gdeli/animal.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"sugar": {
		"hide": false,
		"name": "SUGAR",
		"address": "0x877e7328292277D11752317420f44d6a61B4CD8e",
		"icon": require("../gdeli/deliland-sugar-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"flour": {
		"hide": false,
		"name": "FLOUR",
		"address": "0x217934412c0a70e64c8FF0e0fe2e7b7717fdDCeb",
		"icon": require("../gdeli/deliland-flour-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"gcoil": {
		"hide": false,
		"name": "gcOIL",
		"address": "0x9BF30B6544498AD01cc558c3df44e08892D0952d",
		"icon": require("../gdeli/deliland-gcoil-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"brownsugar": {
		"hide": false,
		"name": "bSUGAR",
		"address": "0x6c2A43fd04E7Ad9bC2b81523E383c445695b73a1",
		"icon": require("../gdeli/deliland-brownsugar-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"wholeflour": {
		"hide": false,
		"name": "wFLOUR",
		"address": "0x7473c63e0247fe25f1388B5eB3dccc412d7a6343",
		"icon": require("../gdeli/deliland-wholeflour-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"gpoil": {
		"hide": false,
		"name": "gpOIL",
		"address": "0xe0D902BcC8c8F15caEe20c57069163C5C1F55ee1",
		"icon": require("../gdeli/deliland-gpoil-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	},
	"puju": {
		"hide": false,
		"name": "puju",
		"address": "0xfc96be3D068582b8eC0bF2dcb4b98826968Ac4Ed",
		"icon": require("../gdeli/deliland-puju-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	}, 
	"momi": {
		"hide": false,
		"name": "momi",
		"address": "0x0A06882d7d8ada90f87720cde5F9929d6DdC38E9",
		"icon": require("../gdeli/deliland-momi-icon.png"),
		"decimals": 18,
		"scope": "?",
		"type": "?",
		"archetype": "",
		"tax": "-",
		"max": "?",
		"staticimg": ""
	}

}
// 0x496e1693a7b162c4f0cd6a1792679cc48ecbcc8d
export const poolConfigs = {
	"0": {
		"stake-name": "gdeli",
		"fee": "0",
		"name": "gDELI",
		"rate": "100",
		"dex": "zoo",
		"action": "buy"
		}, 
	"1": {
		"stake-name": "acre",
		"fee": "0",
		"name": "ACRE",
		"rate": "100",
		"dex": "none",
		"action": "none"
	}, 
	"2": {
		"stake-name": "echo",
		"fee": "0",
		"name": "ECHO",
		"rate": "50",
		"dex": "zoo",
		"action": "buy"
	}, 
	"3": {
		"stake-name": "ftmGdefHyperLP",
		"fee": "0",
		"name": "FTM-GIGADEFLATON HLP",
		"rate": "50",
		"dex": "hyper",
		"action": "add",
		"pairA": "FTM",
		"pairB": "0xb0a3bf98516d6ce466d2f78bd6a494ef8ffb396d"

	}, 
	"4": {
		"stake-name": "ftmDefHyperLP",
		"fee": "0",
		"name": "FTM-DEFLATON HLP",
		"rate": "50",
		"dex": "hyper",
		"action": "add",
		"pairA": "FTM",
		"pairB": "0xfd3b077dc97915ab3a49db1b1021c13ad55751dc"


	}, 
	"5": {
		"stake-name": "ftmGdefSushiLP",
		"fee": "0",
		"name": "FTM-GIGADEFLATON SushiLP",
		"rate": "25",
		"dex": "sushi",
		"action": "add",
		"pairA": "ETH",
		"pairB": "0xb0a3bf98516d6ce466d2f78bd6a494ef8ffb396d"
	}, 
	"6": {
		"stake-name": "ftmDefSushiLP",
		"fee": "0",
		"name": "FTM-DEFLATON SushiLP",
		"rate": "25",
		"dex": "sushi",
		"action": "add",
		"pairA": "ETH",
		"pairB": "0xfd3b077dc97915ab3a49db1b1021c13ad55751dc"
	}, 
	"7": {
		"stake-name": "catnip",
		"fee": "0",
		"name": "CATNIP",
		"rate": "100",
		"dex": "zoo",
		"action": "buy"
	}, 
	

}

export const rewardToken = {
	"name": "acre",
	"displayname": "ACRE",
	"symbol": "ACRE",
	"address": "0x12245af2d6d298D98019C15FB1001D8712D27A7D",
	"icon": require("../gdeli/acre128.png")
}


export const contractConfigs = {
	"generic": {
		"abi": require("../tools/GenericABI.json"),
		"address": "0x12245af2d6d298D98019C15FB1001D8712D27A7D"
	},
	"chef": {
		"abi": require("../deliJS/chefs/AcreMaker.json"),
		"address": "0x3c559c90fD1c7a73D6EaC8510B8Fb16Ca333226F"
	}, 
	"basicitem": {
		"abi": require("../deliJS/BasicItem.json")
	}
}

export const chefs = {
	"acremaker": {
		"abi": require("../deliJS/chefs/AcreMaker.json"),
		"address": "0x3c559c90fD1c7a73D6EaC8510B8Fb16Ca333226F"
	},
	"puchef": {
		"abi": require("../deliJS/chefs/PuChef.json"),
		"address": "0xBB8D08FFB0CaFDFFBb1765a96158805939E270BB"
	},
	"bobachef": {
		"abi": require("../deliJS/chefs/BobaChef.json"),
		"address": "0x3f03e5258868043b762b4d075527672a892a2f21"
	}
}

export const basicItems = {
	"smBOWLwLID": {
		"name":"Small Bowl with Lid",
		"address":"0x0571Da5eAeeEfBA88FFa1f4aBA61c0c596e676D8",
		"base-cost":7,
		"multiplier":2
	},
	"stirSPOON": {
		"name":"Stirring Spoon",
		"address":"0x9E01EB2382674A18945130Fc8F852e405B776477",
		"base-cost":13,
		"multiplier":3
	},
	"bakePAN9x5": {
		"name":"Baking Pan 9x5",
		"address":"0x52424241136D727389221aE5baD77f864BeD0183",
		"base-cost":20,
		"multiplier":5
	}, 
	"bakePANoval": {
		"name":"Oval Baking Pan",
		"address":"0x06F9d0D6FcEd30819ef1D3d704e8dF43Aa83E83c",
		"base-cost":27,
		"multiplier":5
	}, 
	"ROLLINGpin": {
		"name":"Rolling Pin",
		"address":"0x804eB0B7698592CE94c31a1F21c6D63117e74fA9",
		"base-cost":14,
		"multiplier":4
	},
}
export const testItems = {
	"smBOWLwLID": {
		"name":"Small Bowl with Lid",
		"address":"0x1BA7229b0983c1cA5863903a15a5193A2c791684",
		"base-cost":7,
		"multiplier":2
	},
	"stirSPOON": {
		"name":"Stirring Spoon",
		"address":"0x9b4Df9729c5A42bE8065c63363F560F6c5C94489",
		"base-cost":13,
		"multiplier":3
	}, 
	"bakePAN9x5": {
		"name":"Baking Pan 9x5",
		"address":"0x825a2E97473060E522FecADAEcCa1BeaC733a045",
		"base-cost":20,
		"multiplier":5
	}, 
	"bakePANoval": {
		"name":"Oval Baking Pan",
		"address":"0x36e2C68B7f72794C24350aF68D4b6a5B51e74F16",
		"base-cost":27,
		"multiplier":5
	}, 
	"ROLLINGpin": {
		"name":"Rolling Pin",
		"address":"0x95D6FA2409Ae3102762E6E5fAd9b9cF2480D92bB",
		"base-cost":14,
		"multiplier":4
	},
}

export const standardTokens = {
	"dai": {
		"name": "DAI",
		"address": "0x8D11eC38a3EB5E956B052f67Da8Bdc9bef8Abf3E",
		"icon": require("../gdeli/dai-icon.png")
	}
}

export const testTokens = {
	"dai": {
		"name": "fakeDAI",
		"address": "0x37B53840b6820075E9e17ff16D80471E29fE8705",
		"icon": require("../gdeli/dai-icon.png"),
		"abi": require("../tools/fakedai.json")
	}
}
